/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Team_BInputs */

const en_us2_clubs_team_b = /** @type {(inputs: Clubs_Team_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team B`)
};

const pt_br2_clubs_team_b = /** @type {(inputs: Clubs_Team_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time B`)
};

const es_419_clubs_team_b = /** @type {(inputs: Clubs_Team_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo B`)
};

const pt_pt2_clubs_team_b = /** @type {(inputs: Clubs_Team_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipa B`)
};

const fr_fr2_clubs_team_b = /** @type {(inputs: Clubs_Team_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipe B`)
};

const de_de2_clubs_team_b = /** @type {(inputs: Clubs_Team_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team B`)
};

const it_it2_clubs_team_b = /** @type {(inputs: Clubs_Team_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squadra B`)
};

/**
* | output |
* | --- |
* | "Team B" |
*
* @param {Clubs_Team_BInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_team_b = /** @type {((inputs?: Clubs_Team_BInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Team_BInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_team_b(inputs)
	if (locale === "es-419") return es_419_clubs_team_b(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_team_b(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_team_b(inputs)
	if (locale === "de-DE") return de_de2_clubs_team_b(inputs)
	if (locale === "it-IT") return it_it2_clubs_team_b(inputs)
	return en_us2_clubs_team_b(inputs)
});
export { clubs_team_b as "clubs.team_b" }